import httpClient from '../../utils/httpClient';
import { ApiSuccessResponse } from '../../utils/apiSchemas';

const SUBSCRIPTION_BASE_ROUTE = '/api/v1/portal/subscription';

export interface TrialConfigurations {
  enableTrial: boolean;
  trialDays: number;
  trialEndDateFormatted?: string | null;
}

export interface AvailablePlanPublic {
  priceId: string;
  priceValueNormalized: string;
  priceValueNormalizedAsComplementAprox?: string;
  currencyAsComplement?: string;
  dateCotation?: string;
  isProductionPlan?: boolean;
  plansSubscription: number;
  name?: string | null;
  description?: string | null;
  commercialName?: string | null;
  currency?: string | null;
  paymentFrequence?: string | null;
  trialConfigurations?: TrialConfigurations | null;
}

export interface CheckoutPublicResponse {
  urlRedirectCheckout: string | null;
  isSuccesToRedirectToCheckout: boolean;
  shouldRedirectToEnrollment: boolean;
}

export interface CanJumpStepOfSubscriptionResponse {
  canJumpStepOfSubscription: boolean;
  message?: string | null;
  authenticationGuid?: string | null;
}

export const listAvailablePlansPublic = async (
  userAccessGuid: string
): Promise<ApiSuccessResponse<AvailablePlanPublic[]>> => {
  const response = await httpClient.get<ApiSuccessResponse<AvailablePlanPublic[]>>(
    `${SUBSCRIPTION_BASE_ROUTE}/list-available-plans-public?userAccessGuid=${encodeURIComponent(userAccessGuid)}`,
    {
      headers: { 'X-Skip-Auth': 'true' }
    }
  );
  return response.data;
};

export const canJumpStepOfSubscription = async (
  emailAddress: string
): Promise<ApiSuccessResponse<CanJumpStepOfSubscriptionResponse>> => {
  const response = await httpClient.post<ApiSuccessResponse<CanJumpStepOfSubscriptionResponse>>(
    `${SUBSCRIPTION_BASE_ROUTE}/can-jump-step-of-subscription`,
    { emailAddress },
    { headers: { 'X-Skip-Auth': 'true' } }
  );
  return response.data;
};

export const checkoutPublic = async (
  userAccessGuid: string,
  priceId: string
): Promise<ApiSuccessResponse<CheckoutPublicResponse>> => {
  const response = await httpClient.post<ApiSuccessResponse<CheckoutPublicResponse>>(
    `${SUBSCRIPTION_BASE_ROUTE}/checkout-public?userAccessGuid=${encodeURIComponent(userAccessGuid)}`,
    { priceId },
    { headers: { 'X-Skip-Auth': 'true' } }
  );
  return response.data;
};
